import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, BookOpen, FileText, Search, Euro } from "lucide-react";
import { resourceItems } from "../navData";

const GUIDE_ITEMS = [
  {
    href: "/guides/finding-nursing-home-ireland-2026",
    icon: Search,
    title: "Finding a Nursing Home 2026",
    description: "6-chapter interactive guide",
  },
  {
    href: "/guides/fair-deal-application-ireland-2026",
    icon: Euro,
    title: "Fair Deal Application Guide 2026",
    description: "Step-by-step with documents checklist",
  },
];

const MobileResourcesSection = ({ onClose }: { onClose: () => void }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-between py-3 border-b w-full text-left"
      >
        <div className="flex items-center">
          <BookOpen className="h-5 w-5 text-grandpal-green mr-3" />
          <h3 className="font-medium text-gray-800 font-lora">Resources</h3>
        </div>
        <ChevronDown
          className={`h-5 w-5 text-grandpal-green transition-transform duration-200 ${
            isOpen ? 'rotate-180' : 'rotate-0'
          }`}
        />
      </button>
      {isOpen && (
        <div className="py-4 pl-4 space-y-4 animate-fade-in">

          {/* Guides sub-section */}
          <div>
            <h4 className="text-xs uppercase tracking-wide text-grandpal-green font-medium mb-2">
              2026 Interactive Guides
            </h4>
            <div className="space-y-2">
              {GUIDE_ITEMS.map((guide) => {
                const Icon = guide.icon;
                return (
                  <div key={guide.href} className="flex items-start py-1.5">
                    <div className="mr-3 mt-0.5 bg-grandpal-green-light p-2 rounded-md text-grandpal-green shrink-0">
                      <Icon size={16} />
                    </div>
                    <div>
                      <Link
                        to={guide.href}
                        className="block font-medium text-gray-700 hover:text-grandpal-green transition-colors text-sm"
                        onClick={onClose}
                      >
                        {guide.title}
                      </Link>
                      <p className="text-xs text-grandpal-gray mt-0.5">{guide.description}</p>
                    </div>
                  </div>
                );
              })}
              <Link
                to="/guides"
                className="flex items-center gap-1.5 py-1 text-sm text-grandpal-green font-medium"
                onClick={onClose}
              >
                <FileText className="h-3.5 w-3.5" />
                All guides & resources →
              </Link>
            </div>
          </div>

          {/* Other resources */}
          <div>
            <h4 className="text-xs uppercase tracking-wide text-grandpal-green font-medium mb-2">
              Decision Support Tools
            </h4>
            {resourceItems.map((item) => (
              <div key={item.title} className="flex items-start py-2">
                <div className="mr-3 mt-0.5 bg-grandpal-green-light p-2 rounded-md text-grandpal-green">
                  {item.icon}
                </div>
                <div>
                  <Link
                    to={item.path}
                    className="block font-medium text-gray-700 hover:text-grandpal-green transition-colors"
                    onClick={onClose}
                  >
                    {item.title}
                  </Link>
                  <p className="text-sm text-grandpal-gray mt-1">{item.description}</p>
                </div>
              </div>
            ))}
          </div>

        </div>
      )}
    </div>
  );
};

export default MobileResourcesSection;
